export default (props: any) => {
  return (
    <img
      className="finished-ver-chat-icon"
      src="/images/ic_arrow_dropdown.png"
      alt="ic_arrow_dropdown"
    />
  );
};
